import React from 'react'
import ConflictForm from './components/ConflictForm'

const FormView = () => {
  return (
    <>
      <div className='flex flex-wrap flex-1 min-h-full'>
        <div className='p-6 flex-1'>
          <ConflictForm />
        </div>
      </div>
    </>
  )
}

export default FormView
